module.exports = __webpack_public_path__ + "assets/img/poison-potion.cc7b0ab5.png";